import Link from 'molecules/Link';

import { hasArrayValues } from 'utils/array/arrays';

import type { FC } from 'react';

export type ConnectFooterLink = { id: string; label: string; href: string };

export interface ConnectFooterProps {
  copyright?: string;
  links?: ConnectFooterLink[];
}

const DEFAULT_LINKS: ConnectFooterLink[] = [
  { id: 'privacy', label: 'Privacy Policy', href: '/legal/privacy/' },
  { id: 'terms', label: 'Terms of Use', href: '/legal/terms/' },
  { id: 'acceptable-use', label: 'Acceptable Use', href: '/legal/acceptable-use/' },
  { id: 'status', label: 'Status', href: 'https://status.prismatic.io/' },
];

const ConnectFooter: FC<ConnectFooterProps> = ({
  copyright = '© 2026 Prismatic. All rights reserved.',
  links = DEFAULT_LINKS,
}) => (
  <footer className="connect-footer-background py-6">
    <div className="mx-auto flex max-w-screen-xl flex-col items-start gap-4 px-8 sm:flex-row sm:items-center sm:justify-between sm:px-32 lg:px-8">
      <span className="text-md text-white/85">{copyright}</span>

      {hasArrayValues(links) && (
        <div className="flex flex-wrap items-center justify-start gap-x-8 gap-y-2 sm:justify-center">
          {links.map(link => (
            <Link
              key={link.id}
              href={link.href}
              enablePreview={false}
              className="text-md text-white transition-colors hover:text-primary-300"
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  </footer>
);

export default ConnectFooter;
